import {SvgIconComponent} from '@mui/icons-material';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';
import {motion} from 'framer-motion';
import {FeatureStatus} from '../../types/FeatureStatus';

export interface FeatureCardProps {
  title: string;
  description: string;
  IconComponent: SvgIconComponent;
  status: FeatureStatus;
}

export default function FeatureCard({title, description, IconComponent, status}: FeatureCardProps) {
  return (
    <Card
      component={motion.div}
      whileHover={{scale: 1.05}}
      transition={{duration: 0.2}}
      sx={{height: '100%', display: 'flex', flexDirection: 'column'}}
    >
      <CardContent sx={{flexGrow: 1}}>
        <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2}}>
          <IconComponent color="primary" sx={{fontSize: 40}} />
          <Chip
            label={status === FeatureStatus.PROD ? 'Available' : 'Coming Soon'}
            color={status === FeatureStatus.PROD ? 'success' : 'secondary'}
            size="small"
          />
        </Box>
        <Typography variant="h5" component="h2" gutterBottom>
          {title}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {description}
        </Typography>
      </CardContent>
    </Card>
  );
}
